import { combineReducers } from '@reduxjs/toolkit'
import sharepointReducer from 'Features/SharePoint/sharepointSlice'
import adminReducer from 'Features/Admin/adminSlice'

const rootReducer = combineReducers({ sharepoint: sharepointReducer, admin: adminReducer })

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
